export default ({ addToast }) => (error) => {
  console.log('There was an error:', error)
  addToast(`Test action error: "${error.message}".`, {
    appearance: 'error',
  })
}
